import { inject } from "mobx-react";
import React from "react";
import type { Store } from "../../../client/stores";
import * as Webapi from "../generated/webapi.g";
import { generateCatalogUrl } from "../lib/catalog";
import { isCurrentlyPlayingTrackDetailFragment } from "../lib/guards";
import "./Catalog.style.scss";

export enum CatalogKindTypes {
    artist = "artist",
    album = "album",
    station = "station",
    podcast = "podcast",
    curated = "curated",
    song = "song",
}
export interface CatalogLegacyProps {
    id?: string | number;
    track?: Webapi.CurrentlyPlayingTrackDetailFragment | Webapi.TopTrackDetailFragment;
    kind: CatalogKindTypes;
    store?: Store;
}

export const CatalogLegacy = inject("store")(({ store, track, id, kind }: CatalogLegacyProps) => {
    if (!store) {
        return null;
    }
    const currentTrack = track && isCurrentlyPlayingTrackDetailFragment(track) ? track : track?.track;
    const catalogUrl = generateCatalogUrl(store.env, {
        track: currentTrack,
        id,
        kind,
        embed: true,
    });

    if (catalogUrl) {
        return (
            <div className="component-catalog-container">
                <iframe src={catalogUrl} title="Music Catalog" />
            </div>
        );
    }
    return null;
});

export default CatalogLegacy;
